import styled from 'styled-components'

export const Card = styled.div`
  background: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props => props.theme.spacing.sp16};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};

  && .MuiFilledInput-root {
    background-color: ${props => props.theme.colors.background.primary};
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
`

export const TitleAndChip = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  p {
    font-weight: bold;
  }
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
